<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label
            class="inputLabel"
            style="white-space: nowrap; width: 80px"
          >广告主ID：</label>
          <el-input
            v-model="oceanQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label
            class="inputLabel"
            style="white-space: nowrap; width: 80px"
          >广告主名称：</label>
          <el-input
            v-model="oceanQuery.company_name"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label
            class="inputLabel"
            style="white-space: nowrap; width: 80px"
          >广告主状态：</label>
          <el-select
            v-model="oceanQuery.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="searchContainer">
          <label
            class="inputLabel"
            style="white-space: nowrap; width: 80px"
          >审核状态：</label>
          <el-select
            v-model="oceanQuery.approval_status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionstwo"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="info"
          plain
          icon="el-icon-refresh-left"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <div
          class="searchContainer"
          style="float: right"
        >
          <el-button
            class="filter-item"
            type="info"
            plain
            @click="getURLData"
          >授权</el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between"
      >
        <el-table-column
          prop="account_id"
          label="广告主id"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.account_id"
            >
              {{ scope.row.account_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="广告主名称"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.company_name"
            >
              {{ scope.row.company_name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="agent_id"
          label="代理商id"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.agent_id"
            >
              {{ scope.row.agent_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="account_type"
          label="开户类型"
          width="270"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.account_type"
            >
              {{ scope.row.account_type }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="industry"
          label="一级行业"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.industry"
            >
              {{ scope.row.industry }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="secondary_industry"
          label="二级行业"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.secondary_industry"
            >
              {{ scope.row.secondary_industry }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="status_text"
          label="广告主状态"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.status_text"
            >
              {{ scope.row.status_text }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="approval_status_text"
          label="审核状态"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.approval_status_text"
            >
              {{ scope.row.approval_status_text }}
            </p>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { iqiyiadvertiserlist, iqiyiadvertiserauthurl } from '@/api/massiveAdvertising/accountList.js'
export default {
  name: 'AccountList',
  components: {
    PaginationRight
  },
  data() {
    return {
      // 请求参数
      oceanQuery: {
        account_id: '', // 广告主id
        company_name: '', // 广告主名称
        status: '', // NORMAL：正常；FREEZE：冻结
        approval_status: '', // 审核状态（BeforeAudit：审核前；PendingReview：待审核；Passed：通过；Reject：驳回）
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: null,
      loading: false,
      options: [
        {
          value: 'NORMAL',
          label: '正常'
        },
        {
          value: 'FREEZE',
          label: '冻结'
        }
      ],
      optionstwo: [
        {
          value: 'BeforeAudit',
          label: '审核前'
        },
        {
          value: 'PendingReview',
          label: '待审核'
        },
        {
          value: 'Passed',
          label: '通过'
        },
        {
          value: 'Reject',
          label: '驳回'
        }
      ]
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    // 获取账户列表
    getAdvertiserList() {
      this.loading = true
      iqiyiadvertiserlist(this.oceanQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    getURLData() {
      iqiyiadvertiserauthurl().then(res => {
        console.log('res', res.data.url)
        window.open(res.data.url)
      })
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.oceanQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.oceanQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.oceanQuery.page = 1
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.oceanQuery = {
        account_id: '', // 广告主id
        company_name: '', // 广告主名称
        status: '', // NORMAL：正常；FREEZE：冻结
        approval_status: '', // 审核状态（BeforeAudit：审核前；PendingReview：待审核；Passed：通过；Reject：驳回）
        page: 1,
        page_size: 10
      }
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .block {
  justify-content: left;
}
.window__footer {
  margin-top: 20px;
}

.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 10px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 100px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.imgIcon {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  background-size: cover;
  // filter: hue-rotate(90deg);
  filter: grayscale(100%);
}
</style>
